import styles from "./OrdersWorkspace.module.css";

export default function OrderFact({ label, value, icon: Icon }) {
  if (!value) return null;

  return (
    <div className={styles.orderFact}>
      {Icon && <Icon aria-hidden="true" />}
      <span>
        <span className={styles.factLabel}>{label}</span>
        <strong className={styles.factValue}>{value}</strong>
      </span>
    </div>
  );
}
